import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=722ba7d5&scoped=true&"
import script from "./Faqs.vue?vue&type=script&lang=js&"
export * from "./Faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ba7d5",
  null
  
)

export default component.exports